import gql from 'graphql-tag';

const DELETE_PROSPECT_PHONE_CALL = gql` 
  mutation deleteProspectPhoneCall($input: ID!) {
    deleteProspectPhoneCall(phone_call_id: $input) {
      message
      code
    }
  }
`;

export default DELETE_PROSPECT_PHONE_CALL;

